<template>
  <el-dialog
    :class="isPreview ? 'public-preview-dialog' : 'teacher-dialog'"
    :title="isEdit ? '编辑教师信息' : '新建教师信息'"
    :visible.sync="teacherDialogVisible"
    :width="isPreview ? '1400px' : '1300px'"
    :before-close="handleBeforeClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :top="isPreview ? 0 : '15vh'"
  >
    <!-- 预览信息 -->
    <div class="public-preview-boxs" v-if="isPreview">
      <div class="introduce-container">
        <div class="slide-content">
          <breadcrumb :list="breadList"></breadcrumb>
          <div class="slide-box">
            <div class="slide-top">
              <div class="title-box">
                <p class="title">名师照片</p>
              </div>
              <img :src="form.teacherUrl" alt="" />
              <p class="name">{{ form.teacherName }}</p>
            </div>
            <div class="slide-bottom">
              <div class="title-box">
                <p class="title">名师简介</p>
              </div>
              <div class="desc" v-html="form.teacherIntroduce"></div>
            </div>
          </div>
        </div>
        <div class="teacher-info">
          <div class="title-box">
            <p class="title">主要成就</p>
          </div>
          <div class="info-box" v-html="form.teacherAchievement"></div>
        </div>
      </div>
    </div>
    <!-- 表单 -->
    <div class="form-container" v-else>
      <el-form
        ref="teacherForm"
        :model="form"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="教师姓名" prop="teacherName">
          <el-input
            v-model="form.teacherName"
            placeholder="请输入教师姓名"
            maxLength="20"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="名师宣传图片" prop="teacherPropagateUrl">
          <div class="flex">
            <upload
              :list="[]"
              :text="'，图片尺寸为250*190px'"
              @childByValue="
                (file) => {
                  getPic(file, 'teacherPropagateUrl')
                }
              "
            >
            </upload>
            <img
              class="pic"
              v-if="form.teacherPropagateUrl"
              :src="form.teacherPropagateUrl"
            />
          </div>
        </el-form-item>
        <el-form-item label="教师照片" prop="teacherUrl">
          <div class="flex">
            <upload
              :list="[]"
              :text="'，图片尺寸为330*280px'"
              @childByValue="
                (file) => {
                  getPic(file, 'teacherUrl')
                }
              "
            >
            </upload>
            <img class="pic" v-if="form.teacherUrl" :src="form.teacherUrl" />
          </div>
        </el-form-item>
        <el-form-item label="排序号" prop="sortNum">
          <el-input v-model="form.sortNum" placeholder="请输入排序号">
          </el-input>
          <el-tooltip
            class="item"
            effect="dark"
            content="前端展示按照排序号由大到小顺序排列"
            placement="top"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="教师简介" prop="teacherIntroduce">
          <el-input
            v-model="form.teacherIntroduce"
            placeholder="请输入教师简介"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="主要成就" prop="teacherAchievement">
          <quill-editor
            :value="form.teacherAchievement"
            @input="getValue"
          ></quill-editor>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer" v-if="!isPreview">
      <el-button @click="onSubmit('teacherForm', true)">预 览</el-button>
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="onSubmit('teacherForm', false)"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import Upload from '@/components/uploadCopy'
import QuillEditor from '@/components/QuillEditor'
export default {
  components: {
    Upload,
    QuillEditor
  },
  props: {
    teacherDialogVisible: {
      type: Boolean,
      default: false
    },
    teacherInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isPreview: false,
      form: {
        teacherName: '',
        teacherPropagateUrl: '',
        teacherUrl: '',
        sortNum: 1,
        teacherIntroduce: '',
        teacherAchievement: ''
      },
      isEdit: false,
      rules: {
        teacherName: [
          { required: true, message: '教师姓名不能为空', trigger: 'blur' }
        ],
        teacherPropagateUrl: [
          { required: true, message: '名师宣传图片不能为空', trigger: 'change' }
        ],
        teacherUrl: [
          { required: true, message: '教师照片不能为空', trigger: 'change' }
        ],
        teacherIntroduce: [
          { required: true, message: '教师简介不能为空', trigger: 'blur' }
        ],
        teacherAchievement: [
          { required: true, message: '主要成就不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init(data) {
      if (!data) {
        this.isEdit = false
        this.form = {
          teacherName: '',
          teacherPropagateUrl: '',
          teacherUrl: '',
          sortNum: 1,
          teacherIntroduce: '',
          teacherAchievement: ''
        }
        return
      }
      if (data.id) {
        this.form = {
          id: data.id,
          recommendState: data.recommendState,
          teacherName: data.teacherName,
          teacherPropagateUrl: data.teacherPropagateUrl,
          teacherUrl: data.teacherUrl,
          sortNum: data.sortNum,
          teacherIntroduce: data.teacherIntroduce,
          teacherAchievement: data.teacherAchievement
        }
        this.isEdit = true
      }
    },
    // 关闭弹窗前判断是否在预览状态
    handleBeforeClose(done) {
      if (this.form.teacherAchievement && this.form.teacherAchievement !== '<p><br></p>') {
        this.$confirm('此操作将关闭弹窗, 并且不保留您的编辑记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isPreview ? (this.isPreview = false) : this.handleClose()
        }).catch(() => {});
      } else {
        this.isPreview ? (this.isPreview = false) : this.handleClose()
      }
    },
    // 关闭弹窗
    handleClose() {
      this.$emit('close')
    },
    // 上传图片
    getPic(file, current) {
      this.form[current] = file.url
    },
    // 获取富文本信息
    getValue(value) {
      this.form.teacherAchievement = value
    },
    // 提交表单/是否预览
    onSubmit(formName, isPreview) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (isPreview) {
            this.isPreview = isPreview
            return
          }
          if (this.form.teacherAchievement === '<p><br></p>') {
            return this.$message.error('请输入必填项')
          }
          this.$emit('submit', {
            form: this.form,
            isEdit: this.isEdit
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.teacher-dialog {
  ::v-deep .el-dialog {
    .el-dialog__header {
      // background-color: #909399;
      padding: 10px;
      .el-dialog__title {
        font-size: 15px;
        // color: #fff;
      }
      .el-dialog__headerbtn {
        top: 10px;
        i {
          // color: #fff;
        }
      }
    }
    .pic {
      height: 180px;
      border-radius: 4px;
      margin-left: 15px;
    }
    .el-icon-question {
      font-size: 18px;
      margin-left: 10px;
    }
    .upload {
      // width: 250px;
      height: 200px;
      .el-upload .el-upload-dragger {
        width: 250px;
        height: 160px;
      }
    }
    .editor {
      // width: 500px;
      .avatar-uploader,
      .avatar-uploader-video {
        width: 0;
        height: 0;
      }
      .wordNumber {
        display: none;
      }
    }
  }
}
</style>
<style lang='scss'>
.public-preview-boxs {
  background: #eef3ff;
  height: 700px;
  overflow-y: scroll;
  margin: 0 auto;
  .introduce-container {
    width: 1200px;
    margin: 26px auto 0;
    padding: 29px 30px;
    margin-bottom: 40px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    box-sizing: border-box;
    .title-box {
      border-bottom: 2px solid rgba(8, 93, 200, 0.3);
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
      &::before {
        content: '·';
        display: inline-block;
        font-size: 40px;
        color: #ff4e4e;
        position: absolute;
        left: -18px;
      }
      .title {
        width: 113px;
        font-size: 20px;
        font-weight: bold;
        color: #0866cd;
        // padding-bottom: 5px;
        box-sizing: border-box;
        position: relative;
        text-align: center;
        line-height: 35px;
        &::before {
          content: '';
          display: inline-block;
          width: 113px;
          height: 4px;
          background-color: #ff4e4e;
          border-radius: 2px;
          position: absolute;
          bottom: -2px;
          left: 0;
          text-align: center;
        }
      }
    }
    .slide-content {
      width: 375px;
      background-color: #fff;
      box-sizing: border-box;
      .breadcrumb {
        width: 100%;
      }
      .slide-box {
        padding: 0 22px 108px;
        width: 100%;
        box-sizing: border-box;
      }
      .slide-top {
        margin: 35px 0 55px;
        img {
          width: 330px;
          height: 280px;
          margin: 20px 0;
        }
        .name {
          text-align: center;
          font-size: 18px;
          font-weight: bold;
          color: #333;
        }
      }
      .slide-bottom {
        .desc {
          width: 330px;
          margin-top: 20px;
          font-size: 14px;
          color: #333;
          line-height: 24px;
          img {
            height: 280px;
          }
          p {
            width: 330px;
            img {
              width: 330px;
              height: 280px;
            }
          }
        }
      }
    }
    .teacher-info {
      min-width: 800px;
      background-color: #fff;
      box-shadow: 0px 1px 13px 0px rgba(0, 0, 0, 0.08);
      padding: 85px 40px;
      box-sizing: border-box;
      margin-left: 30px;
      overflow-y: scroll;
      .info-box {
        margin-top: 20px;
        font-size: 16px;
        font-weight: bold;
        color: #333;
        line-height: 24px;
        p {
          img {
            width: 100%;
          }
        }
        iframe {
          width: 100%;
          height: 600px;
        }
      }
    }
    .el-dialog__footer {
      width: 100%;
      border-top: 1px solid #ddd;
      padding-top: 15px;
    }
  }
}
</style>